import script from "./ListAccounts.vue?vue&type=script&lang=ts&setup=true"
export * from "./ListAccounts.vue?vue&type=script&lang=ts&setup=true"

import "./ListAccounts.vue?vue&type=style&index=0&id=0a972aee&lang=scss"

export default script